<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
      <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goback()"></span></div>

      <div class="daojia-navbar-left" v-show="$route.query.back" @click="$router.go(-1)"><span
          class="icon-chevron-left"></span></div>
      <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img
            src="../../assets/img/global/logo.png"></a></h1>
      <div class="daojia-navbar-right">
      </div>
    </div>
    <div class="image-box">
      <div class="TitleBackg">
        <div class="weui-flex__item">
          <h1>行李寄存</h1>
          <div>
            <p>解决您回国时行李短期存放难题</p>
            <p>解决您闲置物品的短期存放难题</p>
            <p>解决您货物、库存长期存放难题</p>
          </div>
        </div>
      </div>
      <img src='/static/img/storage/B_04.jpg'>
      <img src='/static/img/storage/B_05.jpg'>
      <img src='/static/img/storage/B_06.jpg'>
      <img src='/static/img/storage/B_07.jpg'>
      <div class="multiLineImg">
        <div class="item">
          <div class="weui-flex">
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/PickupAndDrop-off.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/Sorting.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/clean.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/Monitor.png'">
            </div>
          </div>
          <div class="weui-flex quality">
            <div class="weui-flex__item">
              <div>接货送货</div>
            </div>
            <div class="weui-flex__item">
              <div>分类管理</div>
            </div>
            <div class="weui-flex__item">
              <div>无尘仓库</div>
            </div>
            <div class="weui-flex__item">
              <div>360°监控</div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="weui-flex">
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/keep.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/price.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/Pro.png'">
            </div>
            <div class="weui-flex__item img">
              <img :src="'/static/img/cleanEx/icon/excuse.png'">
            </div>
          </div>
          <div class="weui-flex quality">
            <div class="weui-flex__item">
              <div>无损接管</div>
            </div>
            <div class="weui-flex__item">
              <div>价格透明</div>
            </div>
            <div class="weui-flex__item">
              <div>专业服务</div>
            </div>
            <div class="weui-flex__item">
              <div>全面保障</div>
            </div>
          </div>
        </div>

      </div>
      <div class="service-guarantee">
        <h2>专业服务&nbsp;双重保障</h2>
        <p>1、定制保险，全程护航</p>
        <p>发生财产损坏时及时协商佩服保障您的财产安全。</p>
        <br />
        <p>2、专业客服，保障权益</p>
        <p>专业团队快速响应，如遇问题请联系</p>
        <div class="text_block weui-flex">
          <div class="weui-flex__item">请拨打客服热线：046&nbsp;092&nbsp;1266</div>
          <div class="weui-flex__item text-right">客服微信：daojia006</div>
        </div>
      </div>
    </div>
    <div class="js_dialog" v-show="isLeaving">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">订单尚未完成</strong></div>
        <div class="weui-dialog__bd">确定要回到首页吗？回去后将丢失当前下单进度</div>
        <div class="weui-dialog__ft">
          <div class="weui-dialog__btn weui-dialog__btn_default" @click="isLeaving = false">取消</div>
          <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="goto('/')">回到首页</div>
        </div>
      </div>
    </div>
    <div class="btn-box-fix">
      <div class="btn-container">
        <div class="btn active" @click="goto('/storage-step1')">开始下单</div>
      </div>
    </div>
    <img :src="pixelURL('cangchu', 'jieshao')" class="hide">
</div>
</template>

<script>
export default {
  name: 'work',
  data() {
    return {
      isLeaving: false,
      order: {}
    }
  },
  methods: {
    goback() {
      this.isLeaving = true;
    },
  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    }
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      this.order = localParsed;
    }
    else {
      //this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container {
  padding-top: 50px;
}

.title {
  font-size: 1.4em;
}

.empty {
  padding: 0 20vw;
  text-align: center;
  margin-top: 2vh;
  width: 100vw;
  box-sizing: border-box;
  color: #999;

  a {
    color: #fe9567;
  }
}

.image-box {
  img {
    width: 100%;
  }

  font-size:0;
}

.btn {
  margin-top: 20px;
}

.text {
  text-align: center;
  font-size: 1.2em;
  color: #888;
}

.slogan {
  margin-top: 6px;
  margin-bottom: 5px;
  font-size: 0.8em;
}

.daojia-navbar {
  position: fixed;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 10px;
  box-sizing: border-box;
  height: 50px;
}

.daojia-navbar-left {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: left;

  span {
    font-size: 2em;
    color: #666;
  }
}

.daojia-navbar-middle_logo img {
  height: 34px;
}

.daojia-navbar-middle {
  display: block;
  -webkit-box-flex: 2;
  -webkit-flex: 2;
  flex: 2;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: sans-serif;
  font-size: 1.2em;
  line-height: 1.3;
  font-weight: bold;
}

.daojia-navbar-right {
  font-size: 14px;
  line-height: 26px;
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  text-align: right;
}

.TitleBackg {
  background-size: cover;
  background-position: center;
  padding: 10vh 20vw 10vh 20vw;
  color: #f7f7f7;
  text-align: center;
  font-size: 3.5vw;
  background-image: url(../../../static/img/storage/B_02_1.jpg);

  h1 {
    font-size: 7vw;
    line-height: 40px;
    padding-bottom: 10px;
  }

  p {
    font-size: 3.5vw;
    line-height: 5vw;
    padding-top: 20px;
    padding: 0 0 0 0;
    text-align: justify;
    text-align-last: justify;
  }
}

.multiLineImg {
  padding: 20px 0px 20px 0px;
  color: #666;

  .item {
    padding-top: 10px;
  }

  .img {
    display: flex;
    justify-content: center;
    /*水平居中*/
    align-items: center;
  }

  img {
    width: 12vw;
    height: 12vw;
  }

  .quality {
    width: 100%;
    text-align: center;
    font-size: 3.4vw;
    color: #5A5E68;
  }
}

.service-guarantee {
  background-image: url(../../../static/img/storage/B_9_1.jpg);
  background-size: cover;
  background-position: center;
  padding: 6vw 6vw 10vw 6vw;
  font-size: 3.5vw;
  color: #f7f7f7;
  line-height: 5vw;
  white-space: nowrap;

  h2 {
    text-align: center;
    font-size: 6vw;
    line-height: 1.2em;
    padding: 3vw 0 4vw 0;
  }

  .text-right {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/storage/abstract.vue